import React, { useState } from 'react'
import { Panel, SelectPicker, Input, Row, Col } from 'rsuite'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function AssetBookingManagementDetailForm({
  schema,
  loading,
  onSearch = () => {},
  ...props
}) {
  const [assetCode, setAssetCode] = useState()
  const [assetName, setAssetName] = useState()
  const [assetType, setAssetType] = useState()

  const handleSearch = async () => {
    console.log('handleSearch')

    const request = {
      assetCode: assetCode || '',
      assetName: assetName || '',
      assetType: assetType || '',
    }
    onSearch(request)
  }

  const handleCancel = async () => {
    // console.log('handleCancel')
    setAssetCode('')
    setAssetName('')
    setAssetType('')
    onSearch({})
  }

  return (
    <>
      <Panel header={`${schema.header || 'ค้นหา'}`} bordered collapsible defaultExpanded>
        <Row style={{ marginTop: -10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetCode.label}
            <Input
              placeholder={schema.assetCode.hint || schema.assetCode.label}
              value={assetCode}
              onChange={(value) => {
                setAssetCode(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetName.label}
            <Input
              placeholder={schema.assetName.hint || schema.assetName.label}
              value={assetName}
              onChange={(value) => {
                setAssetName(value)
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>

          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.assetType.label}
            <SelectPicker
              searchable={false}
              data={schema.assetType.options}
              value={assetType}
              block
              placeholder={`เลือก${schema.assetType.label || ''}`}
              onChange={(value) => {
                setAssetType(value)
              }}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <div style={{ marginTop: 22 }}>
              <SearchButton
                disabled={loading}
                onClick={handleSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={handleCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </div>
          </Col>

          <Col lg={4} md={4} sm={24} xs={24}></Col>
        </Row>
      </Panel>
    </>
  )
}
